import React, { useRef } from "react";
import { Divider, Typography } from "@mui/material";
import "../JaldiLab.css";
import {
  getTextContentHeading,
  h1style,
  h2style,
  h3style,
  paraStyle,
  sectionStyle,
} from "./ChapterList";
import objective from "../../../assets/SvgIcons/obj.svg";
import user from "../../../assets/SvgIcons/users.svg";
import adjacencies from "../../../assets/SvgIcons/adjacencies.svg";
import designConsideration from "../../../assets/SvgIcons/design-consideration.svg";

function PoliceInspectorRoom({ goToSection }) {
  const referencesRef = useRef(null);

  const ObjectivesArea = {
    icon: <img src={objective} />,
    heading: "Objectives",
    data: [
      <>
        Ensure that the space is
        <span style={{ color: "#DC002D" }}>
          {" "}
          self-sufficient and comfortable
        </span>
        ; and
      </>,
      <>
        Design the space to ensure that the police officers are able to have
        <span style={{ color: "#DC002D" }}>
          {" "}
          complete visibility of the lock-ups at all points of time{" "}
        </span>{" "}
        to monitor activities.
      </>,
    ],
    isOrdered: false,
    isImage: true,
  };

  const userObject = {
    icon: <img src={user} />,
    heading: "Users",
    data: ["Police officers", "Accompanying staff"],
    isOrdered: false,
    isImage: true,
  };

  const adjacenciesObject = {
    icon: <img src={adjacencies} />,
    heading: "Adjacencies",
    data: [
      "The PI Rooms must be directly accessible from the entrance of the lock-up facilities.",
      "Direct access must be provided to the secure corridors, elevators and stairs between the lock-up and the Courtrooms.",
      "The PI Room must have direct access to the Chambers of the Public Prosecutors.",
    ],
    isOrdered: false,
    isImage: true,
  };

  const DesignConsiderations = {
    icon: <img src={designConsideration} />,
    heading: "Design Considerations",
    data: [
      <>
        The PI Rooms must be designed to have all the facilities as provided in
        a multi-person office space. For further details on the design of a
        multi-person office, please refer to{" "}
        <span
          onClick={() =>
            goToSection("officeSpaces", "officeSpacesMultiPersonWorkspace")
          }
          style={sectionStyle}
        >
          {" "}
          Section 2.5.C.{" "}
        </span>
      </>,
      "The room must be equipped with adequate ergonomic furniture and storage facilities, to store official documents as well as personal belongings of the police officers. ",
      "It must have adequate light and ventilation, and must be well-maintained.",
    ],
    isOrdered: false,
    isImage: true,
  };

  return (
    <div>
      <Typography>
        <h1 id="handbookPrinciple" style={h1style}>
          PART C - THE HANDBOOK
        </h1>{" "}
        <h2 id="HeadingChapterTwo" style={h2style}>
          <span style={{ fontSize: "24px" }}>2. </span>
          ORGANIZATION AND DESIGN OF SPACES OF THE COURT COMPLEX
        </h2>
        <h3 id="facilities" style={h3style}>
          <span style={{ fontSize: "20px" }}>2.7. </span>
          Facilities for Accused Persons
        </h3>
        <h4 id="headingPolice" style={h3style}>
          <span style={{ fontSize: "20px" }}>2.7.</span>C. Police Inspectors’
          Room
        </h4>
        <p style={paraStyle}>
          The Police Inspectors’ (“PI”) Room refers to the office space used by
          the police inspectors accompanying the Accused to the Court Complex as
          well as those who have been called to the Court to present evidence or
          depose in ongoing cases. A dedicated and comfortable working
          environment must be provided for the police officers with adequate
          facilities, to aid them in carrying out their duties.
        </p>
        {getTextContentHeading(ObjectivesArea)}
        {getTextContentHeading(userObject)}
        {getTextContentHeading(adjacenciesObject)}
        {getTextContentHeading(DesignConsiderations)}
      </Typography>
    </div>
  );
}

export default PoliceInspectorRoom;
